module.exports = __webpack_public_path__ + "images/umc_smallb9c576e5f81154ca0010745c94336a4d.png";